import { Component, ViewChild,  TemplateRef } from '@angular/core';
import { UserService } from '../../../services/user.service';
import { Profesional_comp } from '../../../models/profesional_comp.model';
import {Validators, FormBuilder } from '@angular/forms';
import { RutValidator } from 'ng2-rut';
import { FormService } from 'src/app/services/form.service';
import { MatDialog } from '@angular/material';
import { NgxSpinnerComponent, NgxSpinnerService } from 'ngx-spinner';

declare var jQuery: any;
declare var $: any;
@Component({
    selector: "page-profesional_comp",
    templateUrl: "./profesional_comp.component.html",
    providers: [UserService, FormService]
})

export class Profesional_compComponent {

    @ViewChild('openModal') openModal:TemplateRef<any>;
    @ViewChild('openModalNODATA') openModalNODATA: TemplateRef<any>;

    public rut_rep;
    public invalidRut: Boolean;
    public profesional_comp: Profesional_comp;
    public rows = [];
    public actualRow;
    public matcher = new FormService();
    public selectedProC:number = null;

   constructor(private fb: FormBuilder, private _userService: UserService,
     rutValidator: RutValidator, public dialog: MatDialog, private spinner: NgxSpinnerService){
        this.rut_rep = this.fb.group({
        rut: ['', [Validators.required, rutValidator]]
        })
        
        if(!JSON.parse(localStorage.getItem("profesionalComp"))){
            localStorage.setItem("profesionalComp", JSON.stringify(this.rows));
        }else{
            this.rows = JSON.parse(localStorage.getItem("profesionalComp"));
            console.log(this.rows)
        }
        this.invalidRut = true;
            this.profesional_comp = {rut:'', nombre:'',  apellido_mat:'', apellido_pat:'', direccion: '', direccion_num:'', direccion_complemento:'', direccion_completa:'', comuna:'', fono:'', mail:'', recordId:''};
    }

    get_profesional_comp(rut){
        this.spinner.show();
        this._userService.getprofesional_comp(rut).subscribe(
            response => {
                this.spinner.hide();
                if(response.message){
                    this.profesional_comp.rut = rut ? rut : '';
                    this.dialog.open(this.openModal)
                } else {
                    this.profesional_comp.rut = response.rut ? response.rut : '';
                    this.profesional_comp.nombre = response.nombre ? response.nombre : '';
                    this.profesional_comp.apellido_mat = response.apellido_mat ? response.apellido_mat : '';
                    this.profesional_comp.apellido_pat = response.apellido_pat ? response.apellido_pat : '';
                    this.profesional_comp.direccion = response.direccion ? response.direccion : '';
                    this.profesional_comp.direccion_num = response.direccion_num ? response.direccion_num : '';
                    this.profesional_comp.direccion_complemento = response.direccion_complemento ? response.direccion_complemento : '';
                    this.profesional_comp.direccion_completa = response.direccion_completa ? response.direccion_completa : '';
                    this.profesional_comp.comuna = response.comuna ? response.comuna : '';
                    this.profesional_comp.fono = response.fono ? response.fono : '';
                    this.profesional_comp.mail = response.mail ? response.mail : '';
                    this.profesional_comp.recordId = response.recordId ? response.recordId : '';
                    this.dialog.open(this.openModal)
                }

            },
            error => {
                this.spinner.hide();
                console.log(error)
            }
        )
    }

    cleanData(){
        this.profesional_comp = {rut:'', nombre:'',  apellido_mat:'', apellido_pat:'', direccion: '', direccion_num:'', direccion_complemento:'', direccion_completa:'', comuna:'', fono:'', mail:'', recordId:''};
            this.rut_rep.reset()
    }

    update_profesional_comp(rut, id) {
        this.get_profesional_comp(rut);
        this.selectedProC = id;
    }

    saveprofesional_comp() {
        window.scroll(0,0);
        //elimina la fila si escriben un rut que ya esté ingresado
        for (let x = 0; x < this.rows.length; x++) {           
            if (this.profesional_comp.rut == this.rows[x].rut) {                
                this.delete_profesional_comp(x);
            }
        }
        
        //elimina fila cuando la editan
        /*if (this.selectedProC != null) {
            this.delete_profesional_comp(this.selectedProC);
            this.selectedProC = null;
        }*/

        
        this.spinner.show();
        this._userService.saveprofesional_comp(this.profesional_comp).subscribe(
            response => {
                this.spinner.hide();
                console.log(response)
                if(response.update || response.save){
                    $("#rep_modal").modal("hide");
                    this.actualRow = localStorage.getItem("profesionalComp");
                    this.rows = JSON.parse(this.actualRow);
                    this.rows = this.rows.concat({
                        rut: this.profesional_comp.rut,
                        nombre: this.profesional_comp.nombre,
                        apellido_pat: this.profesional_comp.apellido_pat,
                        apellido_mat: this.profesional_comp.apellido_mat,
                        direccion:this.profesional_comp.direccion, 
                        direccion_num:this.profesional_comp.direccion_num, 
                        direccion_complemento:this.profesional_comp.direccion_complemento, 
                        direccion_completa:this.profesional_comp.direccion_completa, 
                        comuna:this.profesional_comp.comuna, 
                        fono:this.profesional_comp.fono,
                        mail:this.profesional_comp.mail
                    })
                    localStorage.setItem("profesionalComp", JSON.stringify(this.rows));
                    this.profesional_comp = {rut:'', nombre:'',  apellido_mat:'', apellido_pat:'', direccion: '', direccion_num:'', direccion_complemento:'', direccion_completa:'', comuna:'', fono:'', mail:'', recordId:''};
                    this.rut_rep.reset()
                    this.dialog.closeAll();
                     
                }
            },
            error => {
                this.spinner.hide();
                console.log(error)
            }
        )
    }
    delete_profesional_comp(id) {
        for (let x = 0; x < this.rows.length; x++) {
            if (id == x) {
                this.rows.splice(x, 1);
                localStorage.setItem("profesionalComp", JSON.stringify(this.rows));
                this.rows = JSON.parse(localStorage.getItem('profesionalComp'));
            }
        }
    }
}